import clsx from 'clsx';

type DividerProps = {
	className?: string;
};

const Divider = ({ className = 'my-5' }: DividerProps) => {
	return (
		<div className="row">
			<div className="col-12">
				<div className={clsx('separator', className)} />
			</div>
		</div>
	);
};

export default Divider;
